module.exports = __webpack_public_path__ + "static/media/medidas_camiseta_g.517656ac.png";